import React from 'react'
import './contact.css'

const contact = () => {
  return (
    <section class="contact" id="contact">
      <div class='content'>
        <h1 class='Fifth'>Get in Touch</h1>
      </div>
      <div class="container2">
        <div class="contactInfo">
          <div class="box">
            <div class="icon"><i class="fa fa-phone" aria-hidden="true"></i></div>
            <div class="text">
              <h3>Phone No</h3>
              <p>+91 9557008087</p>
            </div>
          </div>
          <div class="box">
            <div class="icon"><i class="fa fa-envelope" aria-hidden="true"></i></div>
            <div class="text">
              <h3 class='sixth'>Email Id</h3>
              <a href='https://mail.google.com/mail/u/1/?hl=en_GB#inbox' target="_blank">prathamrushil2003@gmail.com</a>
            </div>
          </div>
          <div class="box">
            <div class="icon"><i class="fa-brands fa-instagram"></i></div>
            <div class="text">
              <h3 class='seventh'>Instagram</h3>
              <a href="https://www.instagram.com/pratham__kandari03/" target="_blank">pratham__kandari03</a>
            </div>
          </div>
        </div>
        <div class="contactForm">
          <form>
            <h2>Send Message</h2>
            <div class="inputBox">
              <input type="text" class="" required="required" />
              <span>Full Name</span>
            </div>
            <div class="inputBox">
              <input type="text" class="" required="required" />
              <span>Email</span>
            </div>
            <div class="inputBox">
              <textarea required='required'></textarea>
              <span>Type your Message...</span>
            </div>
            <div class="inputBox">
              <input type="submit" name="" value="Send" />
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default contact